
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { GhostBrandIcon } from './PartnerIcons';

interface LogoProps {
  variant?: 'light' | 'dark';
  type?: 'wallet' | 'os';
}

export const Logo: React.FC<LogoProps> = ({ variant = 'light', type = 'wallet' }) => {
  const isDark = variant === 'dark';
  const suffix = type === 'wallet' ? 'Pay' : 'OS';
  const subText = type === 'os' ? 'Version 1.0.0 Beta' : null;

  const textColor = isDark ? 'text-white' : 'text-[#0A0B0F]';

  return (
    <div className="flex items-center gap-3 group cursor-pointer shrink-0">
        <div className={`
            w-9 h-9 md:w-10 md:h-10 flex items-center justify-center 
            transition-all duration-500 group-hover:scale-110 group-hover:-rotate-12
            relative overflow-visible shrink-0
        `}>
          <GhostBrandIcon className={`w-full h-full drop-shadow-xl`} />
        </div>
        {subText ? (
             <div className="flex flex-col text-left">
                <h1 className={`font-serif text-base md:text-lg tracking-tight ${textColor} leading-none`}>
                    <span className="font-light">Ghost</span><span className="font-bold">{suffix}</span>
                </h1>
                <div className="text-[8px] md:text-[9px] text-stone-500 uppercase tracking-[0.2em] font-bold mt-1.5">{subText}</div>
             </div>
        ) : (
            <span className={`font-serif text-xl md:text-2xl tracking-tight ${textColor}`}>
                <span className="font-light">Ghost</span><span className="font-bold">{suffix}</span>
            </span>
        )}
    </div>
  );
};
